import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import {updateSearchCondition} from '../../actions';


import Pagination from '../../components/pagination';

const NAVSIZE = 10;

class PageContainer extends Component {
  

  handlePageChange(pageNumber) {
    const { handlePageChange, logCondition, handleActivePage} = this.props;
    handlePageChange((pageNumber-1) * logCondition.pageSize);
    handleActivePage(pageNumber);
  }

  render() {
    const {
      pageFrom,
      activePage
    } = this.props;
    const {
      pageSize,
      totalCount
    } = this.props.logCondition;
   
    return (
      <div className="page-container">
        {totalCount > 0 && 
        <Fragment>
          {/* <div className="import">* 180일 이후 자동삭제 됩니다.</div> */}
          <Pagination
            activePage={activePage}
            beginIndex={pageFrom}
            count={10}
            itemsCountPerPage={pageSize}
            totalCount={totalCount}
            pageRangeDisplayed={NAVSIZE}
            handlePageChange={this.handlePageChange.bind(this)}
          />
          <div className="list-total"><span>{`${totalCount} 건`}</span></div>
        </Fragment>
        }
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    logCondition: state.logCondition
  }
};


PageContainer = connect(mapStateToProps)(PageContainer);


export default PageContainer;


// WEBPACK FOOTER //
// ./src/containers/downloadlog/PageContainer.js